import "./Description.scss";

const Description = (props) => {
    return (
        <p className="description-text">{props.descriptionText}</p>
    )
};

export default Description;